// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Sd from "common/src/tft-static/Sd.bs.js";
import * as Caml from "rescript/lib/es6/caml.js";
import * as Data from "common/src/data/Data.bs.js";
import * as Patch from "common/src/Patch.bs.js";
import * as Trait from "common/src/data/Trait.bs.js";
import * as React from "react";
import * as Global from "common/src/Global.bs.js";
import * as TftSet from "common/src/data/TftSet.bs.js";
import * as Js_dict from "rescript/lib/es6/js_dict.js";
import * as AdLayout from "../app-core/AdLayout.bs.js";
import * as ItemImage from "common/src/tft-static/ItemImage.bs.js";
import * as UnitImage from "common/src/tft-static/UnitImage.bs.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as TraitImage from "common/src/tft-static/TraitImage.bs.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as ItemTooltip from "common/src/tft-static/ItemTooltip.bs.js";
import * as StatsConfig from "../stats/StatsConfig.bs.js";
import * as Translation from "common/src/bindings/Translation.bs.js";
import * as UnitTooltip from "common/src/tft-static/UnitTooltip.bs.js";
import * as TraitTooltip from "common/src/tft-static/TraitTooltip.bs.js";
import * as Belt_SortArray from "rescript/lib/es6/belt_SortArray.js";
import * as ContentSection from "common/src/ContentSection.bs.js";
import TrendingUp from "@mui/icons-material/TrendingUp";
import ArrowDropUp from "@mui/icons-material/ArrowDropUp";
import TrendingDown from "@mui/icons-material/TrendingDown";
import ArrowDropDown from "@mui/icons-material/ArrowDropDown";

function TrendsPage$Trends(Props) {
  var s1Count = Props.s1Count;
  var s2Count = Props.s2Count;
  var s1Place = Props.s1Place;
  var s2Place = Props.s2Place;
  var currStats = Props.currStats;
  var pastStats = Props.pastStats;
  var pr1 = Global.f(s1Count) / Global.f(currStats.totalEntries) * 8;
  var pr2 = Global.f(s2Count) / Global.f(pastStats.totalEntries) * 8;
  var dPr = pr1 - pr2;
  var dPlace = s1Place - s2Place;
  return React.createElement("div", {
              className: "pl-2 h-12 flex flex-col justify-center"
            }, React.createElement("div", {
                  className: "flex items-center"
                }, Global.toFixed(undefined, pr1), React.createElement("span", {
                      className: dPr >= 0 ? "text-green-11" : "text-red-11"
                    }, React.createElement("span", {
                          className: "inline-block px-[1px]"
                        }, pr1 > pr2 ? React.createElement(ArrowDropUp, {
                                color: "inherit",
                                viewBox: "3 3 18 18"
                              }) : React.createElement(ArrowDropDown, {
                                color: "inherit",
                                viewBox: "3 3 18 18"
                              })), "(" + (
                      dPr >= 0.005 ? "+" : ""
                    ) + Global.toFixed(undefined, dPr) + ")")), React.createElement("div", {
                  className: "flex items-center"
                }, Global.toFixed(undefined, s1Place), React.createElement("span", {
                      className: dPlace <= 0 ? "text-green-11" : "text-red-11"
                    }, React.createElement("span", {
                          className: "inline-block px-[1px]"
                        }, s2Place > s1Place ? React.createElement(ArrowDropDown, {
                                color: "inherit",
                                viewBox: "3 3 18 18"
                              }) : React.createElement(ArrowDropUp, {
                                color: "inherit",
                                viewBox: "3 3 18 18"
                              })), "(" + (
                      dPlace >= 0.005 ? "+" : ""
                    ) + Global.toFixed(undefined, dPlace) + ")")));
}

var Trends = {
  make: TrendsPage$Trends
};

function TrendsPage(Props) {
  var currStats = Props.currStats;
  var pastStats = Props.pastStats;
  var prevPatch = Props.prevPatch;
  var currPatch = Props.currPatch;
  if (pastStats === undefined) {
    return React.createElement(AdLayout.make, {
                children: React.createElement(ContentSection.make, {
                      className: "sm:w-[640px] text-base leading-snug self-center",
                      children: "Trends not available for the first patch of the set."
                    })
              });
  }
  var t = Translation.useT(/* Common */0);
  var set = TftSet.use(undefined);
  var units = Belt_Array.keepMap(Js_dict.entries(currStats.units), (function (param) {
          var stats = param[1];
          var id = param[0];
          return Belt_Option.map(Js_dict.get(pastStats.units, id), (function (ps) {
                        return [
                                id,
                                stats,
                                ps
                              ];
                      }));
        }));
  var traits = Belt_Array.keep(Belt_Array.keepMap(Js_dict.entries(currStats.traits), (function (param) {
              var stats = param[1];
              var id = param[0];
              return Belt_Option.map(Js_dict.get(pastStats.traits, id), (function (ps) {
                            return [
                                    id,
                                    stats,
                                    ps
                                  ];
                          }));
            })), (function (param) {
          if (Global.f(param[1].count) / Global.f(currStats.totalEntries) > 0.00125) {
            return true;
          } else {
            return Global.f(param[2].count) / Global.f(pastStats.totalEntries) > 0.00125;
          }
        }));
  var items = Belt_Array.keep(Belt_Array.keepMap(currStats.items, (function (item) {
              return Belt_Option.map(Caml_option.undefined_to_opt(pastStats.items.find(function (item2) {
                                  return item.itemId === item2.itemId;
                                })), (function (ps) {
                            return [
                                    item,
                                    ps
                                  ];
                          }));
            })), (function (param) {
          var tags = Data.itemInfoExn(param[0].itemId, set).tags;
          return !(tags.includes("Other") || tags.includes("Radiant"));
        }));
  return React.createElement(AdLayout.make, {
              children: null
            }, React.createElement(ContentSection.make, {
                  className: "sm:w-[640px] text-base leading-snug self-center",
                  children: React.createElement("div", undefined, React.createElement("div", {
                            className: "flex gap-3"
                          }, React.createElement("h2", {
                                className: "text-lg font-montserrat font-semibold pb-2 pr-4"
                              }, t("Top Trends")), React.createElement(StatsConfig.RankGroupSelect.make, {}), React.createElement(StatsConfig.QueueSelect.make, {})), "Biggest changes in play rate and average placement from " + Patch.render(prevPatch) + " to " + Patch.render(currPatch) + ". Make sure to pick the right comps to invest your precious LP in!")
                }), React.createElement("div", {
                  className: "flex flex-col justify-center gap-8 mt-6"
                }, React.createElement("div", {
                      className: "flex justify-center lg:justify-between text-sm flex-wrap gap-8"
                    }, React.createElement(ContentSection.make, {
                          children: null,
                          noPadding: true
                        }, React.createElement(ContentSection.Header.make, {
                              title: t("Units")
                            }), React.createElement("div", {
                              className: "p-4 flex gap-8"
                            }, React.createElement("div", {
                                  className: "flex flex-col gap-5"
                                }, React.createElement("div", {
                                      className: "flex items-center gap-1 text-lg font-medium text-green-11 self-center mb-[-6px]"
                                    }, React.createElement(TrendingUp, {
                                          color: "inherit"
                                        }), t("Trending Up")), Belt_Array.map(Belt_Array.slice(Belt_SortArray.stableSortBy(units, (function (param, param$1) {
                                                return Caml.caml_float_compare(param[1].place - param[2].place, param$1[1].place - param$1[2].place);
                                              })), 0, 12), (function (param) {
                                        var s2 = param[2];
                                        var s1 = param[1];
                                        var unitId = param[0];
                                        return React.createElement("div", {
                                                    key: unitId,
                                                    className: "flex items-center"
                                                  }, React.createElement(UnitTooltip.make, {
                                                        unit: unitId,
                                                        children: React.createElement(UnitImage.make, {
                                                              unitId: unitId,
                                                              size: 36,
                                                              className: "mr-[2px]"
                                                            })
                                                      }), React.createElement(TrendsPage$Trends, {
                                                        s1Count: s1.count,
                                                        s2Count: s2.count,
                                                        s1Place: s1.place,
                                                        s2Place: s2.place,
                                                        currStats: currStats,
                                                        pastStats: pastStats
                                                      }));
                                      }))), React.createElement("div", {
                                  className: "flex flex-col gap-5"
                                }, React.createElement("div", {
                                      className: "flex items-center gap-1 text-lg font-medium text-red-11 self-center mb-[-6px]"
                                    }, React.createElement(TrendingDown, {
                                          color: "inherit"
                                        }), t("Trending Down")), Belt_Array.map(Belt_Array.slice(Belt_SortArray.stableSortBy(units, (function (param, param$1) {
                                                return Caml.caml_float_compare(param$1[1].place - param$1[2].place, param[1].place - param[2].place);
                                              })), 0, 12), (function (param) {
                                        var s2 = param[2];
                                        var s1 = param[1];
                                        var unitId = param[0];
                                        return React.createElement("div", {
                                                    key: unitId,
                                                    className: "flex items-center"
                                                  }, React.createElement(UnitTooltip.make, {
                                                        unit: unitId,
                                                        children: React.createElement(UnitImage.make, {
                                                              unitId: unitId,
                                                              size: 36,
                                                              className: "mr-[2px]"
                                                            })
                                                      }), React.createElement(TrendsPage$Trends, {
                                                        s1Count: s1.count,
                                                        s2Count: s2.count,
                                                        s1Place: s1.place,
                                                        s2Place: s2.place,
                                                        currStats: currStats,
                                                        pastStats: pastStats
                                                      }));
                                      }))))), React.createElement(ContentSection.make, {
                          children: null,
                          noPadding: true
                        }, React.createElement(ContentSection.Header.make, {
                              title: t("Traits")
                            }), React.createElement("div", {
                              className: "p-4 flex gap-8"
                            }, React.createElement("div", {
                                  className: "flex flex-col gap-5"
                                }, React.createElement("div", {
                                      className: "flex items-center gap-1 text-lg font-medium text-green-11 self-center mb-[-6px]"
                                    }, React.createElement(TrendingUp, {
                                          color: "inherit"
                                        }), t("Trending Up")), Belt_Array.map(Belt_Array.slice(Belt_SortArray.stableSortBy(Belt_Array.keep(traits, (function (param) {
                                                    return !Sd.isTraitUnique(Trait.fromRankTraitId2(param[0])[0], set);
                                                  })), (function (param, param$1) {
                                                return Caml.caml_float_compare(param[1].place - param[2].place, param$1[1].place - param$1[2].place);
                                              })), 0, 12), (function (param) {
                                        var s2 = param[2];
                                        var s1 = param[1];
                                        var rtid = param[0];
                                        var match = Trait.fromRankTraitId2(rtid);
                                        var rank = match[1];
                                        var traitId = match[0];
                                        return React.createElement("div", {
                                                    key: rtid,
                                                    className: "flex items-center"
                                                  }, React.createElement(TraitTooltip.make, {
                                                        trait: traitId,
                                                        rank: rank,
                                                        children: React.createElement(TraitImage.PlainIcon2.make, {
                                                              traitId: traitId,
                                                              rank: rank,
                                                              size: 38
                                                            })
                                                      }), React.createElement(TrendsPage$Trends, {
                                                        s1Count: s1.count,
                                                        s2Count: s2.count,
                                                        s1Place: s1.place,
                                                        s2Place: s2.place,
                                                        currStats: currStats,
                                                        pastStats: pastStats
                                                      }));
                                      }))), React.createElement("div", {
                                  className: "flex flex-col gap-5"
                                }, React.createElement("div", {
                                      className: "flex items-center gap-1 text-lg font-medium text-red-11 self-center mb-[-6px]"
                                    }, React.createElement(TrendingDown, {
                                          color: "inherit"
                                        }), t("Trending Down")), Belt_Array.map(Belt_Array.slice(Belt_SortArray.stableSortBy(Belt_Array.keep(traits, (function (param) {
                                                    return !Sd.isTraitUnique(Trait.fromRankTraitId2(param[0])[0], set);
                                                  })), (function (param, param$1) {
                                                return Caml.caml_float_compare(param$1[1].place - param$1[2].place, param[1].place - param[2].place);
                                              })), 0, 12), (function (param) {
                                        var s2 = param[2];
                                        var s1 = param[1];
                                        var rtid = param[0];
                                        var match = Trait.fromRankTraitId2(rtid);
                                        var rank = match[1];
                                        var traitId = match[0];
                                        return React.createElement("div", {
                                                    key: rtid,
                                                    className: "flex items-center"
                                                  }, React.createElement(TraitTooltip.make, {
                                                        trait: traitId,
                                                        rank: rank,
                                                        children: React.createElement(TraitImage.PlainIcon2.make, {
                                                              traitId: traitId,
                                                              rank: rank,
                                                              size: 38
                                                            })
                                                      }), React.createElement(TrendsPage$Trends, {
                                                        s1Count: s1.count,
                                                        s2Count: s2.count,
                                                        s1Place: s1.place,
                                                        s2Place: s2.place,
                                                        currStats: currStats,
                                                        pastStats: pastStats
                                                      }));
                                      }))))), React.createElement(ContentSection.make, {
                          children: null,
                          noPadding: true
                        }, React.createElement(ContentSection.Header.make, {
                              title: t("Items")
                            }), React.createElement("div", {
                              className: "p-4 flex gap-8"
                            }, React.createElement("div", {
                                  className: "flex flex-col gap-5"
                                }, React.createElement("div", {
                                      className: "flex items-center gap-1 text-lg font-medium text-green-11 self-center mb-[-6px]"
                                    }, React.createElement(TrendingUp, {
                                          color: "inherit"
                                        }), t("Trending Up")), Belt_Array.map(Belt_Array.slice(Belt_SortArray.stableSortBy(items, (function (param, param$1) {
                                                return Caml.caml_float_compare(param[0].place - param[1].place, param$1[0].place - param$1[1].place);
                                              })), 0, 12), (function (param) {
                                        var s2 = param[1];
                                        var s1 = param[0];
                                        var itemId = s1.itemId;
                                        return React.createElement("div", {
                                                    key: itemId,
                                                    className: "flex items-center"
                                                  }, React.createElement(ItemTooltip.make, {
                                                        itemId: itemId,
                                                        children: React.createElement(ItemImage.make, {
                                                              itemId: itemId,
                                                              size: 36,
                                                              className: "mr-[2px]"
                                                            })
                                                      }), React.createElement(TrendsPage$Trends, {
                                                        s1Count: s1.count,
                                                        s2Count: s2.count,
                                                        s1Place: s1.place,
                                                        s2Place: s2.place,
                                                        currStats: currStats,
                                                        pastStats: pastStats
                                                      }));
                                      }))), React.createElement("div", {
                                  className: "flex flex-col gap-5"
                                }, React.createElement("div", {
                                      className: "flex items-center gap-1 text-lg font-medium text-red-11 self-center mb-[-6px]"
                                    }, React.createElement(TrendingDown, {
                                          color: "inherit"
                                        }), t("Trending Down")), Belt_Array.map(Belt_Array.slice(Belt_SortArray.stableSortBy(items, (function (param, param$1) {
                                                return Caml.caml_float_compare(param$1[0].place - param$1[1].place, param[0].place - param[1].place);
                                              })), 0, 12), (function (param) {
                                        var s2 = param[1];
                                        var s1 = param[0];
                                        var itemId = s1.itemId;
                                        return React.createElement("div", {
                                                    key: itemId,
                                                    className: "flex items-center"
                                                  }, React.createElement(ItemTooltip.make, {
                                                        itemId: itemId,
                                                        children: React.createElement(ItemImage.make, {
                                                              itemId: itemId,
                                                              size: 36,
                                                              className: "mr-[2px]"
                                                            })
                                                      }), React.createElement(TrendsPage$Trends, {
                                                        s1Count: s1.count,
                                                        s2Count: s2.count,
                                                        s1Place: s1.place,
                                                        s2Place: s2.place,
                                                        currStats: currStats,
                                                        pastStats: pastStats
                                                      }));
                                      }))))))));
}

var imgSize = 38;

var listLen = 12;

var make = TrendsPage;

export {
  Trends ,
  imgSize ,
  listLen ,
  make ,
  
}
/* Sd Not a pure module */
